(function(){
  var d=document;
  function $(s,c){return (c||d).querySelector(s)}
  function $$(s,c){return Array.prototype.slice.call((c||d).querySelectorAll(s))}
  function toast(msg){var t=$('[data-ak-toast]');if(!t)return;t.textContent=msg;t.classList.add('is-on');clearTimeout(t._t);t._t=setTimeout(function(){t.classList.remove('is-on')},2200)}

  // Mobile menu
  $$('[data-ak-menu-open]').forEach(function(b){b.addEventListener('click',function(){var m=$('[data-ak-drawer]');if(m){m.classList.add('is-open');d.body.style.overflow='hidden'}})});
  $$('[data-ak-menu-close]').forEach(function(b){b.addEventListener('click',function(){var m=$('[data-ak-drawer]');if(m){m.classList.remove('is-open');d.body.style.overflow=''}})});

  // Gallery
  $$('[data-ak-gal]').forEach(function(g){
    var tr=$('[data-ak-track]',g), dots=$$('[data-ak-dot]',g), th=$$('[data-ak-thumb]',g);
    if(!tr)return;
    function go(i){tr.scrollTo({left:tr.clientWidth*i,behavior:'smooth'})}
    dots.concat(th).forEach(function(b){b.addEventListener('click',function(){go(+b.getAttribute('data-i'))})});
    var raf;
    tr.addEventListener('scroll',function(){cancelAnimationFrame(raf);raf=requestAnimationFrame(function(){
      var i=Math.round(tr.scrollLeft/tr.clientWidth);
      dots.forEach(function(x,k){x.classList.toggle('is-on',k===i)});th.forEach(function(x,k){x.classList.toggle('is-on',k===i);if(k===i&&x.parentNode.scrollTo)x.parentNode.scrollTo({left:x.offsetLeft-x.parentNode.offsetWidth/2+x.offsetWidth/2,behavior:'smooth'})});var cn=$('[data-ak-count]',g);if(cn)cn.textContent=(i+1)+' / '+th.length;
    })},{passive:true});
  });

  // Quantity
  $$('[data-ak-qty]').forEach(function(q){
    var i=$('input',q);
    $$('button',q).forEach(function(b){b.addEventListener('click',function(){
      var v=parseInt(i.value||'1',10)+(b.hasAttribute('data-plus')?1:-1);i.value=Math.max(1,Math.min(10,v));
      $$('[data-ak-qty-mirror]').forEach(function(m){m.value=i.value});
    })});
  });

  // Delivery date
  $$('[data-ak-deliv]').forEach(function(el){
    var a=parseInt(el.getAttribute('data-min')||'4',10), b=parseInt(el.getAttribute('data-max')||'7',10);
    function f(n){var x=new Date();x.setDate(x.getDate()+n);return x.toLocaleDateString('en-IN',{weekday:'short',day:'numeric',month:'short'})}
    el.textContent=f(a)+' – '+f(b);
  });

  // Add to cart (AJAX) + Buy now (direct checkout)
  function updateCount(){fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(c){$$('[data-ak-count]').forEach(function(n){n.textContent=c.item_count;n.hidden=!c.item_count})}).catch(function(){})}
  $$('form[data-ak-form]').forEach(function(f){
    f.addEventListener('submit',function(e){
      var btn=e.submitter||d.activeElement, mode=btn&&btn.getAttribute('data-ak-mode');
      if(mode!=='add')return; // buy now: native submit with return_to=/checkout
      e.preventDefault();
      var fd=new FormData(f);fd.delete('return_to');
      btn.disabled=true;
      fetch('/cart/add.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(){toast('Added to cart');updateCount()}).catch(function(){f.submit()}).finally(function(){btn.disabled=false});
    });
  });
  $$('[data-ak-sticky-buy]').forEach(function(b){b.addEventListener('click',function(e){
    var f=$('form[data-ak-form]');if(!f)return;e.preventDefault();
    var nb=$('[data-ak-mode="buy"]',f); if(f.requestSubmit&&nb){f.requestSubmit(nb)}else{f.submit()}
  })});

  // Sticky bar
  var st=$('[data-ak-sticky]'), anchor=$('[data-ak-buy]');
  if(st&&anchor&&'IntersectionObserver' in window){
    d.body.classList.add('ak-has-sticky');
    new IntersectionObserver(function(en){en.forEach(function(x){
      var past=x.boundingClientRect.top<0; st.classList.toggle('is-on',!x.isIntersecting&&past);
    })},{threshold:0}).observe(anchor);
  }

  // Cart quantity buttons
  $$('[data-ak-line]').forEach(function(l){
    var line=l.getAttribute('data-ak-line');
    $$('[data-ak-set]',l).forEach(function(b){b.addEventListener('click',function(){
      var q=parseInt(b.getAttribute('data-ak-set'),10);
      fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:+line,quantity:q})}).then(function(){location.reload()});
    })});
  });
})();
